import { useParams } from "react-router-dom";
import { paymentApi } from "../../store/services/PaymentService";
import { useSelector } from "react-redux";
import logo from "../../assets/logo_svg_white.svg";
import pcidss from "../../assets/PCI-DSS-logo.jpg";
import ssl from "../../assets/ssl-icon.avif";
import mastercard_sc from "../../assets/mastercard-securecode.jpg";
import visa_verif from "../../assets/verified-by-visa.jpg";
import amex_safeK from "../../assets/amex-safekey-logo.avif";

export default function Footer() {

    const { id } = useParams();
    const { data } = useSelector(paymentApi.endpoints.getPayment.select(id));
    let customColor = data?.customColor;

    const circuitLogos:any = {
        "mastercard": mastercard_sc,
        "visa": visa_verif,
        "amex": amex_safeK
    };
    return(
        <>
            <footer className="bottom-0 z-[999] bg-white">
                <div className="h-20 flex items-center justify-center gap-2">
                    <img src={ssl} alt="SSL secure" className="h-12 h-8-max" />
                    <img src={pcidss} alt="PCI-DSS" className="h-12 h-8-max" />

                    {data?.circuits?.map((circuit:string) => (
                        circuitLogos[circuit] ? (
                            <img
                                key={circuit}
                                src={circuitLogos[circuit]}
                                alt={circuit}
                                className="h-12 h-8-max"
                            />
                        ) : null
                    ))}
                </div>
                <div className="h-20 flex items-center justify-center bg-skin-bgFooter" style={customColor ? { backgroundColor: customColor } : {}}>
                    <a className="text-skin-footer text-base underline flex items-center" rel="noopener noreferrer" target="_blank" href="https://www.fnmpay.it/wp-content/uploads/2024/05/Informativa-privacy-dati-pagamento-utenti-finali.pdf">
                        Powered by 
                        {data?.shopLogo ? <img className="h-10 ml-2" src={logo} alt="Logo Cliente" /> : " FNMpay"}
                    </a>
                </div>
            </footer>
        </>
    )
}